import React from 'react';

import { useFavoriteListing } from '../hooks/useFavoriteListing';

interface Children {
  onClick: React.MouseEventHandler;
  isLoading: boolean;
  isFavorite: boolean;
}

interface Props {
  listingId: number;
  isTenantMULFlowEnabled: boolean;
  children: (p: Children) => JSX.Element;
}

export const FavoriteListingContainer: React.FC<Props> = ({
  children,
  listingId,
  isTenantMULFlowEnabled,
}) => {
  const { isFavorite, isLoading, onClick } = useFavoriteListing(
    listingId,
    isTenantMULFlowEnabled,
  );

  return children({
    onClick,
    isFavorite,
    isLoading,
  });
};
